import { NgModule } from '@angular/core';

import { DvlaLookupMotHistoryComponent }            from './dvla-lookup.mot-history.component';
import { DvlaLookupMotHistoryExpandedRowComponent } from './dvla-lookup.mot-history.row.expanded.component';
import { DvlaLookupService }                        from './dvla-lookup.service';
import { PurchaseDvlaLookupsComponent }             from './dvla-lookup.purchase.component';
import { SharedModule }                             from '../shared/shared.module';
import { TableModule }                              from '../table/table.module';

@NgModule({
  declarations: [
    DvlaLookupMotHistoryComponent,
    DvlaLookupMotHistoryExpandedRowComponent,
    PurchaseDvlaLookupsComponent
  ],
  entryComponents: [
    DvlaLookupMotHistoryComponent,
    DvlaLookupMotHistoryExpandedRowComponent,
    PurchaseDvlaLookupsComponent
  ],
  imports: [
    SharedModule,
    TableModule
  ],
  providers: [
    DvlaLookupService
  ]
})
export class DvlaLookupModule {}
